export function urlFragmentParams() {
  if (false) {
    return new URLSearchParams();
  } else {
    const fragment = window.location.hash.substring(1);
    return new URLSearchParams(fragment);
  }
}